"use client";

import { useState } from "react";

type DeletionEmailActionsProps = {
  email: string;
  requestHref: string;
};

export function DeletionEmailActions({ email, requestHref }: DeletionEmailActionsProps) {
  const [copyStatus, setCopyStatus] = useState<"idle" | "copied" | "failed">("idle");

  async function copyEmail() {
    try {
      await navigator.clipboard.writeText(email);
      setCopyStatus("copied");
    } catch {
      setCopyStatus("failed");
    }
  }

  return (
    <div className="deletion-contact-actions">
      <a href={requestHref} className="site-cta">
        Email a deletion request
      </a>
      <div className="deletion-contact-email"><a href={`mailto:${email}`}>{email}</a><button
        type="button"
        onClick={copyEmail}
        aria-label={copyStatus === "copied" ? "Email copied" : "Copy email address"}
        title="Copy email address"
      >
        <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><rect x="8" y="8" width="12" height="13" rx="2"/><path d="M16 8V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h3"/></svg>
      </button></div>
      <span className="deletion-copy-status" role="status">
        {copyStatus === "failed" ? "Couldn’t copy. Select the address or open your email app." : copyStatus === "copied" ? "Email address copied." : ""}
      </span>
    </div>
  );
}
